// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoldenFilledSvg from "@ant-design/icons-svg/es/asn/GoldenFilled";
import AntdIcon from '../components/AntdIcon';

var GoldenFilled = function GoldenFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoldenFilledSvg
  }));
};

GoldenFilled.displayName = 'GoldenFilled';
export default React.forwardRef(GoldenFilled);